import { render, staticRenderFns } from "./dashboard-logo.vue?vue&type=template&id=245e2c60&"
import script from "./dashboard-logo.vue?vue&type=script&lang=js&"
export * from "./dashboard-logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports